import { useMemo } from 'react';
import { usePlaces } from '@/hooks/usePlaces';
import { useFavorites } from '@/hooks/useFavorites';
import { PlaceCard } from '@/components/PlaceCard';

export function FavoritesPage() {
  const { places, loading } = usePlaces();
  const { isFavorite, toggle, loaded } = useFavorites();

  const favorites = useMemo(() => (places ?? []).filter((p) => isFavorite(p.id)), [places, isFavorite]);

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Family Favorites</h1>
        <p className="page-subtitle">The family's go-to spots — tap the heart on any place</p>
      </div>
      {(loading || !loaded) && <div className="skeleton" style={{ height: 140 }} />}
      {!loading && loaded && favorites.length === 0 && (
        <p className="empty-state">Tap the heart on any place to save it here.</p>
      )}
      {favorites.map((p) => (
        <PlaceCard key={p.id} place={p} isFavorite onToggleFavorite={toggle} />
      ))}
    </div>
  );
}
